module.exports = __webpack_public_path__ + "media/images/partners/7_stuttgart-596c6529830035ea9e40e95569835711.png";